import { ConcealmentDeltas } from 'utils/webrtc/stats/types';

const BURST_THRESHOLD = 5;
const BURST_FACTOR = 1.3;
const RATE_WEIGHT = 4;
const SILENT_WEIGHT = 2;

export function concealmentPenalty(deltas: ConcealmentDeltas): number {
  if (deltas.totalSamplesReceived <= 0) {
    return 0;
  }

  const concealmentRate = deltas.concealedSamples / deltas.totalSamplesReceived;
  const silentRate =
    deltas.concealedSamples > 0 ? deltas.silentConcealedSamples / deltas.concealedSamples : 0;
  const burstinessAdjust = deltas.concealmentEvents > BURST_THRESHOLD ? BURST_FACTOR : 1.0;

  return (
    burstinessAdjust *
    (RATE_WEIGHT * concealmentRate + SILENT_WEIGHT * silentRate * concealmentRate)
  );
}

// Surfaced as "audio impairment %" on audio TrackScores for the Stage 2 dashboard.
export function computeAudioImpairmentPct(deltas: ConcealmentDeltas): number {
  if (deltas.totalSamplesReceived <= 0) {
    return 0;
  }
  const rate = deltas.concealedSamples / deltas.totalSamplesReceived;
  return Math.round(rate * 1000) / 10;
}
